import React, { useState } from "react";

const FAQItem = ({ question, answer }) => {
  const [open, setOpen] = useState(false);

  return (
    <div className="ml-8">
      <button
        onClick={() => setOpen(!open)}
        className="bg-gray-200 px-3 py-2 md:text-xl rounded-md w-full text-left text-sm font-semibold flex items-center justify-between"
      >
        {question}
        <img
          src="/images/arrows/flecha3.webp"
          alt="toggle"
          className={`h-4 w-6 transition-transform duration-200 ${open ? "rotate-180" : ""}`}
        />
      </button>

      {open && (
        <div className="md:text-base text-left bg-gray-50 border-l-4 border-green-500 rounded-md px-3 py-2 mt-1 text-sm text-gray-700 leading-relaxed">
          {answer}
        </div>
      )}
    </div>
  );
};

export default FAQItem;
